import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import LancamentosFinanceiros1 from '../imagens/LancLancamentosFinanceiros/LancamentosFinanceiros1.png';
import LancamentosFinanceiros2 from '../imagens/LancLancamentosFinanceiros/LancamentosFinanceiros2.png';
import LancamentosFinanceiros3 from '../imagens/LancLancamentosFinanceiros/LancamentosFinanceiros3.png';
import LancamentosFinanceiros4 from '../imagens/LancLancamentosFinanceiros/LancamentosFinanceiros4.png';
import LancamentosFinanceiros5 from '../imagens/LancLancamentosFinanceiros/LancamentosFinanceiros5.png';
import LancamentosFinanceiros6 from '../imagens/LancLancamentosFinanceiros/LancamentosFinanceiros6.png';
import LancamentosFinanceiros7 from '../imagens/LancLancamentosFinanceiros/LancamentosFinanceiros7.png';
import LancamentosFinanceiros8 from '../imagens/LancLancamentosFinanceiros/LancamentosFinanceiros8.png';

export default class LancamentosFinanceiros extends Component {

  render() {

    const { isOpen, onClose } = this.props;

    return (
      <Modal
        title="Como criar Lançamentos Financeiros"
        className="modal"
        visible={isOpen}
        destroyOnClose
        onCancel={onClose}
        footer={null}
        width="50%"
        style={{ top: 10 }}
      >
        <Row>
          <Col xs={24}>
            <p>Para acessar a criação de Lançamento Financeiro siga o seguinte atalho:  </p>

            <div className="image-wrapper">
              <img className="img_smaller" src={LancamentosFinanceiros1} alt="Lancamentos 1"/>
            </div>     

            <div className="gray_bar"></div>

            <div className="image-wrapper">
              <img src={LancamentosFinanceiros2} alt="Lancamentos 2"/>
            </div>     

                        
          <h3>Na tela de Lançamentos Financeiros nós temos:</h3>
            <ol>
                <li>Botão para cadastrar um novo Lançamento.</li> 
                <li>Filtros para buscar os lançamentos.</li>
                <li>Tabela mostrando todas os lançamentos financeiros cadastrados.</li>
                <li>Botões auxiliares de alteração/exclusão/impressão do Lançamento.</li>
                <li>Paginação da tabela de Lançamentos.</li>                
            </ol>   

            <div className="gray_bar"></div>

            <h3>Como registrar um novo Lançamento Financeiro</h3>

            <p>
              Para cadastrar um novo Lançamento basta clicar no botão "Adicionar" no canto superior esquerdo da tela e inserir os dados necessários da página de cadastro
              que é aberta.
            </p>     
            <div className="image-wrapper">
              <img src={LancamentosFinanceiros3} alt="Lancamentos 3"/>
            </div>  
            <p>
              O cadastro de Lançamentos Financeiros possui duas abas: A aba de dados principais e a aba de Forma de Pagamento. A aba de dados principais serve para definir 
              as informações gerais do lançamento. Nela você pode definir o valor do lançamento e depois ao clicar no botão "Calcular Parcelas", o sistema irá calcular 
              a quantidade de parcelas e valor das parcelas que seram exibidos na segunda aba.
            </p>  
            <div  className="image-wrapper">
              <img src={LancamentosFinanceiros4} alt="Lancamentos 4"/>
            </div>  
            <p>
              Na segunda aba é mostrado as parcelas e valores calculados na primeira aba. Caso você deseje alterar as parcelas volte para a primeira aba e altere as informações
              conforme necessário.
            </p> 
            <p>
                Após terminar de preeencher as informações e verificar que as parcelas foram calculadas corretamente, basta clicar no botão "Salvar" para salvar e 
                terminar o cadastro do Lançamento Financeiro.
            </p>
            <div  className="image-wrapper">
              <img src={LancamentosFinanceiros5} alt="Lancamentos 5"/>
            </div>   

            <div className="gray_bar"></div>    

            <h3>Relação dos Lançamentos financeiros com o controle de Caixa</h3> 

            <p>
              Caso a sua empresa use o controle de caixa da plataforma, aqui será explicado qual a relação entre Lançamentos financeiros e os Caixas. Caso
              o gestor não utilize o controle de Caixa, você pode ignorar essa parte. 
            </p>              

            <p>
              Quando o Caixa foi criado para o dia, se o caixa estiver fechado o gestor não poderá fazer Lançamentos financeiros, nem alterar lançamentos ja digitados. 
              Para poder realizar lançamentos financeiro tenha certeza que o Caixa esteja aberto. Caso você tenha dúvida sobre o Caixa, acesse o gerenciamento de caixa
              seguindo o caminho da imagem a baixo.  
            </p>

            <div className="image-wrapper">
              <img className="img_smaller" src={LancamentosFinanceiros8} alt="Lancamentos 1"/>
            </div>              

            <div className="gray_bar"></div>    

            <h3>Como alterar/Excluir um Lançamento</h3>     
            <p>Para  Alterar/Excluir um Lançamento utilize as opções extras dentro da tabela de registros.</p>    
            <div  className="image-wrapper">
              <img src={LancamentosFinanceiros6} alt="Lancamentos 6"/>
            </div>     

            <div className="gray_bar"></div>               

            <h3>Como filtrar os Lançamentos</h3>   
            <p>Para facilitar a busca de Lançamentos você pode utilizar os filtros avançados clicando no botão "Filtrar."</p>              
            <div  className="image-wrapper">
              <img src={LancamentosFinanceiros7} alt="Lancamentos 7"/>
            </div>                                
          </Col>
        </Row>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/tutoriais/LancLancamentosFinanceiros.js